import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import {
  ActiveFacetsModule,
  FacetModule,
  ListNavigationModule,
  MediaModule,
  OutletPosition,
  PaginationModule,
  ProductImagesModule,
  provideOutlet
} from '@spartacus/storefront';
import { NoMouseScrollModule } from '../shared/directives/no-mouse-scroll/no-mouse-scroll.module';
import { CustomBannerComponent } from './custom-banner/custom-banner.component';
import { CustomProductCardComponent } from './custom-product-card/custom-product-card.component';
import { CustomProductPageComponent } from './custom-product-page/custom-product-page.component';
import { CustomProductRefinementComponent } from './custom-product-refinement/custom-product-refinement.component';
import { ReorderRibbonComponent } from './reorder-ribbon/reorder-ribbon.component';
import { TabComponent } from './tabs/tab.component';
import { TabsComponent } from './tabs/tabs.component';

@NgModule({
  declarations: [
    CustomProductPageComponent,
    CustomProductRefinementComponent,
    CustomProductCardComponent,
    TabsComponent,
    TabComponent,
    ReorderRibbonComponent,
    CustomBannerComponent,
  ],
  exports: [CustomProductCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ListNavigationModule,
    FacetModule,
    PaginationModule,
    ProductImagesModule,
    ActiveFacetsModule,
    MediaModule,
    RouterModule,
    I18nModule,
    NgSelectModule,
    BrowserModule,
    NoMouseScrollModule,
    MatProgressSpinnerModule,
    ConfigModule.withConfig({
      pagination: {
        addStart: false,
        addEnd: false,
        addPrevious: true,
        addNext: true,
        nextLabel: '>',
        previousLabel: '<',
        addFirst: false,
        addLast: false,
        addDots: false,
        rangeCount: false,
      },
      cmsComponents: {
        ProductGridComponent: {
          component: () =>
            import('./custom-product-page/custom-product-page.component').then(
              (m) => m.CustomProductPageComponent
            ),
        },
        SearchResultsGridComponent: {
          component: () =>
            import('./custom-product-page/custom-product-page.component').then(
              (m) => m.CustomProductPageComponent
            ),
        },
        ProductRefinementComponent: {
          component: () =>
            import(
              './custom-product-refinement/custom-product-refinement.component'
            ).then((m) => m.CustomProductRefinementComponent),
        },
        FutureShipModelComponent: {
          component: () =>
            import('./reorder-ribbon/reorder-ribbon.component').then(
              (m) => m.ReorderRibbonComponent
            ),
        },
        ProductGridPageVerticalBannerComponent: {
          component: () =>
            import('./plp-banner/plp-banner.component').then(
              (m) => m.PlpBannerComponent
            ),
          editable: true,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideOutlet({
      id: 'ProductGridHorizontalBanner',
      position: OutletPosition.REPLACE,
      component: CustomBannerComponent,
    }),
  ],
})
export class CustomProdPgModule {}
